import { render, staticRenderFns } from "./Hojagrafica.vue?vue&type=template&id=6c1fc3a3&scoped=true"
import script from "./Hojagrafica.vue?vue&type=script&lang=js"
export * from "./Hojagrafica.vue?vue&type=script&lang=js"
import style0 from "./Hojagrafica.vue?vue&type=style&index=0&id=6c1fc3a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1fc3a3",
  null
  
)

export default component.exports